// extracted by mini-css-extract-plugin
module.exports = {"plainWhiteButton":"ButtonPlain_plainWhiteButton__2wYyE","spin":"ButtonPlain_spin__3rpau","transition-opacity":"ButtonPlain_transition-opacity__325IO"};